import { OriginationTracking, getOriginationFromUrl } from '@applyonline/shared'
import { createContext, useContext, useMemo, useState } from 'react'


export interface TAppStore {
  originationFromUrl: OriginationTracking | null
}

export const AppContext = createContext<TAppStore | null>(null)

export function useAppStoreProvider() {
  const [originationFromUrl] = useState<OriginationTracking | null>(getOriginationFromUrl(window.location.search))

  return useMemo(
    () => ({
      originationFromUrl,
    }),
    [originationFromUrl],
  )
}

export function useAppStore(): TAppStore {
  return useContext(AppContext)!
}
